import type { SealogEventGeographyResponse } from "@/apiClient/models/SealogEventGeographyResponse";

type SealogDatum = {
  data_name?: string | null;
  data_value?: string | null;
};

type SealogAuxData = {
  data_array?: SealogDatum[] | null;
};

type SealogEventPayload = {
  aux_data?: SealogAuxData[] | null;
};

export const retrieveSealogTimestamps = (
  items: SealogEventGeographyResponse[],
  fullPath: string
) => {
  const filename = fullPath.split("/").pop();
  const timestamps: string[] = [];

  items.forEach((item) => {
    const event = item.event as SealogEventPayload | undefined;
    (event?.aux_data ?? []).forEach((aux) => {
      const dataArray = aux.data_array ?? [];
      const matchesFile = dataArray.some(
        (datum) =>
          datum.data_name === "filename" && datum.data_value === filename
      );
      const elapseTime = dataArray.find(
        (datum) => datum.data_name === "elapse_time"
      )?.data_value;

      if (matchesFile && elapseTime) {
        timestamps.push(elapseTime.split(".")[0]);
      }
    });
  });

  return timestamps;
};
